package com.esoris.kmpmoout.app.multiplatform_settings

import com.russhwolf.settings.Settings
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

class AppSettings(
    private val settings: Settings
) {

    companion object {
        private const val ANON_ID_KEY = "anon_id"
    }

    private val _anonId =
        MutableStateFlow(
            settings.getStringOrNull(ANON_ID_KEY)
        )

    val anonId = _anonId.asStateFlow()

    fun setAnonId(anonId: String) {

        settings.putString(
            ANON_ID_KEY,
            anonId
        )

        _anonId.update {
            anonId
        }
    }

    fun getAnonId(): String? {
        return settings.getStringOrNull(ANON_ID_KEY)
    }
}